<template>
  <div>
    <v-app>
      <v-container>
        <!-- タイトル -->
        <v-row justify="center">
          <v-col cols="auto" class="text-h6 pb-0">{{ title }} </v-col>
        </v-row>

        <!-- エラー画像 -->
        <v-row justify="center" class="mt-8 mb-8">
          <v-img max-width="120" :src="iconUrl"></v-img>
        </v-row>

        <!-- テキスト -->
        <v-row align="center" justify="center" class="mt-4 pl-4 pr-4">
          <v-col cols="auto"
            ><span class="pre-wrap text-body-1" v-text="text"></span
          ></v-col>
        </v-row>
      </v-container>

      <!-- 店舗情報 -->
      <!-- <v-container v-if="about != null" class="pl-16 pr-16">
        <v-row justify="center" align="center">
          <v-col cols="auto" class="text-body-2">店舗連絡先</v-col>
          <v-col cols="auto" class="text-body-2">
            <a :href="`tel:${about.phone}`">{{ about.phone }}</a>
          </v-col>
        </v-row>
      </v-container> -->

      <!-- footer -->
      <!-- トーク画面へ移動 -->
      <!-- <v-container>
        <v-row justify="center" class="mt-8">
          <v-btn
            v-if="linkTalkScreen"
            rounded
            class="custom-transform-class text-none"
            color="success"
            :href="linkTalkScreen"
            >トーク画面へ移動</v-btn
          >
        </v-row>
      </v-container> -->
    </v-app>
  </div>
</template>

<script>
// import { mapGetters, mapActions } from "vuex";
import { commonError } from "./errorConstants";
const IMAGE_SORRY = require("@/assets/sorry.png");

export default {
  data: () => ({
    errorNo: "",
    orderNo: "",

    // アイコン
    iconUrl: IMAGE_SORRY,
    title: "",
    text: "",
  }),
  created() {
    this.$store.state.appBar = false;
    this.$store.state.title = "エラー";
    this.$store.state.cart = false;
  },
  mounted() {
    // 表示メッセージ設定
    const msgType = this.$route.query.msgType;
    this.bindMessages(msgType);
  },
  watch: {
    // DB 設定読み込んだ後に行う
    // db: function () {
    //   // 店舗情報表示
    //   this.showShopInfo();
    //   this.hideProgress();
    // },
  },
  computed: {
    // ...mapGetters("settings", ["linkTalkScreen", "db"]),
    // ...mapGetters(["about"]),
  },
  methods: {
    // ...mapActions(["showProgress", "hideProgress", "fetchAbout"]),
    bindMessages: function (msgType) {
      const message = commonError.findMessage(msgType);
      this.title = message.title;
      this.text = message.text;
    },
    showShopInfo: async function () {
      this.fetchAbout();
    },
  },
};
</script>
<style>
@import "../../css/common.css";
</style>